module.exports = __webpack_public_path__ + "static/media/icon_pgcode_card_bundle.284cf1b5.svg";